export const stories = [
  {
    title: "iPhone 5",
    params: {
      viewport: { defaultViewport: "iphone5" }
    }
  },
  {
    title: "iPhone 6",
    params: {
      viewport: { defaultViewport: "iphone6" }
    }
  },
  {
    title: "iPhone X",
    params: {
      viewport: { defaultViewport: "iphonex" }
    }
  },
  {
    title: "iPad",
    params: {
      viewport: { defaultViewport: "ipad" }
    }
  },
  {
    title: "Desktop",
    params: {
      viewport: { defaultViewport: "desktop" }
    }
  }
];
